var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroup127(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5069 14.3072L17.4979 14.3822C15.299 13.2862 15.069 13.1402 14.785 13.5662C14.588 13.8612 14.014 14.5302 13.841 14.7282C13.666 14.9232 13.492 14.9382 13.195 14.8032C12.895 14.6532 11.932 14.3382 10.7921 13.3182C9.90407 12.5232 9.30808 11.5482 9.13208 11.2482C8.83909 10.7422 9.45207 10.6702 10.0101 9.61426C10.1101 9.40427 10.0591 9.23927 9.98506 9.09027C9.91007 8.94028 9.31308 7.4703 9.06308 6.88431C8.82309 6.30032 8.57609 6.37432 8.39109 6.37432C7.8151 6.32432 7.39411 6.33232 7.02312 6.71832C5.40915 8.49228 5.81614 10.3222 7.19712 12.2682C9.91107 15.8202 11.357 16.4741 14.001 17.3821C14.715 17.6091 15.366 17.5771 15.881 17.5031C16.4549 17.4121 17.6479 16.7821 17.8969 16.0771C18.1519 15.3722 18.1519 14.7872 18.0769 14.6522C18.0029 14.5172 17.8069 14.4422 17.5069 14.3072Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5196 3.44937C12.8308 -3.9835 0.105998 1.40741 0.100998 11.8932C0.100998 13.9892 0.649988 16.0331 1.69597 17.8381L0 24L6.33488 22.348C14.2397 26.618 23.9956 20.9481 23.9996 11.8992C23.9996 8.72327 22.7596 5.73433 20.5046 3.48837L20.5196 3.44937ZM22.0016 11.8662C21.9956 19.4991 13.6168 24.266 6.98987 20.3701L6.62988 20.1561L2.87995 21.1311L3.88493 17.4861L3.64593 17.1111C-0.477991 10.5462 4.25992 1.9664 12.0718 1.9664C14.7257 1.9664 17.2167 3.00138 19.0927 4.87634C20.9676 6.73531 22.0016 9.22627 22.0016 11.8662Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup127);
export default __webpack_public_path__ + "static/media/Group 127.3572f2ae25dafa0681bac96bf74b3e28.svg";
export { ForwardRef as ReactComponent };